$(document).ready(function ($) {
  if (getEST("-5")) {
      $("#csChatPopupChatFloating").show();
  } else {
      $("#csChatPopupChatFloating").hide();
  }
  setInterval(
      function () {
          if (getEST("-5")) {
                  if(!$(".cschat-chatpopup").length) {
              $("#csChatPopupChatFloating").show();
              }
          } else {
              $("#csChatPopupChatFloating").hide();
          }

      },
  000);
  var flag = false;
  var cart_btn = $('.product-options-bottom.available .btn-cart');
  var cta_intr = setInterval(function(){
      if($('.product-options-bottom.available .btn-cart').hasClass('pre-button')) {
          $('.product-options-bottom.available .btn-cart').removeClass('pre-button');
      }
  },2000);

  if($('#quicklink_button_span').length) {
      $('#quicklink_button_span').text($('#quicklink_button_span').attr('class'));
  }
  // var currency = setInterval(function(){
  //     if($('.locale-selectors__container').length > 0) {
  //         var temp = $('.locale-selectors__container');
  //         temp.prependTo('.top-links-container .top-links-area');
  //         temp.find('select').css('background-color', 'white !important');
  //         clearInterval(currency);
  //     }
  // }, 100);
});
function getEST(offset) {
  d = new Date();
  utc = d.getTime() + (d.getTimezoneOffset() * 60000);
  nd = new Date(utc + (3600000 * offset));

  var start_time = new Date();
  start_time.setHours(7, 0, 0);

  var end_time = new Date();
  end_time.setHours(19, 0, 0);
  if (nd >= start_time && nd < end_time && nd.getDay() > 0 && nd.getDay() < 6) {
      return true;
  } else {
      return false;
  }
  return false;
}
var chatButtonID = document.getElementById('csChatPopupChat');

// STAGING URL
var chatURL = 'https://chat.ovloop.com/?organizationId=ba85a449-6eec-45bc-be66-262cda79230b';

// Turn floating button ON or OFF. Floating button creates itself, ID for button is #csChatPopupChatFloating
var useFloatingButton = true;


//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////



if ( ! useFloatingButton ) {
    // Static button ID
    var chatButtonID = document.getElementById('csChatPopupChat');
    chatButtonID.addEventListener('click', appendChatWindow);

} else {

    document.addEventListener('DOMContentLoaded', function() {

        //var cschatButton = '<div class="cschat-chatpopup-button-wrapper"><button id="csChatPopupChat" class="csChatFloatingButton">Live Chat</button></div>';
        var elem = document.createElement('div');
        elem.classList.add('cschat-chatpopup-button-wrapper');
        elem.style.cssText = 'display:block;';
        elem.innerHTML = '<button id="csChatPopupChatFloating" class="csChatFloatingButton" alt="Start Live Chat" title="Start Live Chat">Start Live Chat</button>';

        document.body.appendChild(elem);

        // Look for floating button ID
        var chatButtonID = document.getElementById('csChatPopupChatFloating');

        // Add click listener to Live Chat button. 
        chatButtonID.addEventListener('click', appendChatWindow);

    }, false);

}


/**
 * This function appends a div with class name 'cschat-chatpopup' to bottom of <body> tag. 
 * Chat window appears in bottom right of desktop screens.
 * If mobile browser, this function will open up new tab in browser instead of chat popup window. 
 */
function appendChatWindow() {

    var elem = document.getElementsByClassName('cschat-chatpopup');

    // Check to see if cschat-chatpopup exists in DOM. If not, then create new div. If so, then disable button push. 
    // Protects against multiple windows opening up.
    if (elem.length === 0) {
    
        // For mobile browsers
        if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            
            window.open(chatURL, '_blank');

        // For desktop browsers
        } else {

            // Hide floating button if applicable
            if ( useFloatingButton ) {
                document.getElementById('csChatPopupChatFloating').style.display = "none";
            }

            var elem = document.createElement('div');
            elem.classList.add('cschat-chatpopup');
            elem.style.cssText = 'display:block;';
            elem.innerHTML = '<div id="closeChat">' +
                             '<a href="javascript:;" onclick="closeChatWindow()" style="" aria-label="Close modal"><span>&times;</span> Close chat</a>' +
                             '</div>' +
                             '<iframe frameborder="0" height="500" width="100%"  allow="microphone" src="' + chatURL + '"></iframe>';

            document.body.appendChild(elem);
        }   
    } else {
        // console.log('appendChatWindow false');
        return false;

    }
};

/**
 * This function closes the chat window. Actually destroys the html.   
 */
function closeChatWindow() {
    var closeWindow = document.getElementsByClassName('cschat-chatpopup');
    closeWindow[0].parentNode.removeChild(closeWindow[0]);

    if ( useFloatingButton ) {
        document.getElementById('csChatPopupChatFloating').style.display = "block";
    }
}
